import { IFaireCategory, IFaireCategoryTransformed } from "../models/types/faire.types";

/**
 * The function takes an array of original categories, transforms them into a new format, and adds a
 * default category at the beginning.
 */
export function addCategoryAndTransform(originalCategories: IFaireCategory[]): IFaireCategoryTransformed[] {
  const transformedCategories = originalCategories?.map((originalCategory) => ({
    id: originalCategory.taxonomy_type_id,
    value: originalCategory.name,
  }));

  return [...transformedCategories];
}
